import {
  getMedian,
  getStandardDeviation
} from '@blisspointmedia/bpm-types/dist/brandHealthMetricsUtils';

const getQuarterThresholds = (start: number, end: number): number[] => {
  const step = (end - start) / 4;
  return [start + step, start + 2 * step, start + 3 * step];
};

export const getThresholdBinsWithStdDev = (gqvMapData: number[]): number[] => {
  const minIndex = Math.min(...gqvMapData);
  const maxIndex = Math.max(...gqvMapData);
  const median = getMedian(gqvMapData);
  const stdDev = getStandardDeviation(gqvMapData);
  const adjustedCeiling = median + 2.5 * stdDev;
  const adjustedMaxIndex = Math.min(maxIndex, adjustedCeiling);

  return [
    minIndex,
    ...getQuarterThresholds(minIndex, 1),
    1,
    ...getQuarterThresholds(1, adjustedMaxIndex),
    adjustedMaxIndex
  ];
};
